<script setup lang="ts">
defineProps<{
  link: string;
}>();

// In-memory only: dismissing hides it for this page view, but it returns on reload.
const dismissed = ref(false);
</script>

<template>
  <Transition name="ta-slide">
    <div v-if="!dismissed" class="fixed inset-x-0 bottom-0 z-50 p-3 pointer-events-none">
      <div
        class="pointer-events-auto mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-stone-200 bg-white p-3 shadow-soft-lg">
        <img src="/tripadvisor-logo.png" alt="Tripadvisor" class="h-10 w-10 shrink-0" />

        <div class="min-w-0 flex-1 text-left">
          <p class="text-sm font-semibold leading-tight text-gray-900">{{ $t('tripadvisorTitle') }}</p>
          <p class="truncate text-xs leading-tight text-gray-500">{{ $t('tripadvisorSubtitle') }}</p>
        </div>

        <a
          :href="link"
          target="_blank"
          rel="noopener noreferrer"
          class="shrink-0 rounded-lg bg-[#34E0A1] px-4 py-2 text-sm font-semibold text-gray-900 transition-colors hover:bg-[#28c78d]">
          {{ $t('tripadvisorButton') }}
        </a>

        <button
          type="button"
          :aria-label="$t('tripadvisorDismiss')"
          class="-mr-1 shrink-0 rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
          @click="dismissed = true">
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.ta-slide-enter-active,
.ta-slide-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

.ta-slide-enter-from,
.ta-slide-leave-to {
  transform: translateY(120%);
  opacity: 0;
}
</style>
